import React, {Fragment, useEffect, useRef, useState} from 'react';
import moment from 'moment';
import { useDispatch, useSelector} from 'react-redux';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {getClientAndDriverIdData} from "../../actions/product-delivery";
import {getMaterialOptions} from "../../actions/material";
import {clearErrors} from "../../actions/sale";
import Select from "react-select";
import {addForTransportProductDelivery, getForTransportProductDeliveries} from "../../actions/transport";
import {getSelectedOption} from "../../utils/hooks/getParams";

const TransportProductDeliveryCreateForm = (props) => {
    const {
        transport_id,
        show,
        handleShow,
        handleClose
    } = props;

    const dispatch = useDispatch();
    const {driver_options, client_options} = useSelector(state => state.product_delivery);
    const {material_options} = useSelector(state => state.material);

    const {
        transport_product_deliveries,
        error, loading
    } = useSelector(state => state.transport);

    useEffect(() => {
        dispatch(getClientAndDriverIdData());
        dispatch(getMaterialOptions());
    }, [getClientAndDriverIdData]);

    const [clientOptions, setClientOptions] = useState([]);
    const [driverOptions, setDriverOptions] = useState([]);
    const [materialOptions, setMaterialOptions] = useState([]);

    useEffect(() => {
        const items = [];
        if (material_options) {
            material_options.forEach((item) => items.push({
                label: `${item.name}`,
                value: item.id
            }));
        }
        setMaterialOptions(items);
    }, [material_options]);

    useEffect(() => {

        const items = [];
        if (client_options) {
            client_options.forEach((item) => items.push({
                label: `${item.name}`,
                value: item.id
            }));
        }
        setClientOptions(items);
    }, [client_options]);

    useEffect(() => {
        const items = [];
        if (driver_options) {
            driver_options.forEach((item) => items.push({
                label: `${item.name || " " + item?.first_name}`,
                value: item.id
            }));
        }
        setDriverOptions(items);
    }, [driver_options]);

    const formRef = useRef();

    const defaultValues = {
        transport_id: '',
        client_id: '',
        driver_id: '',
        round: '',
        price: '',
        // Ixtiyoriy: shu reysda tashilgan material (qum, tosh, ...)
        material_id: '',
        // Yetkazib berish sanasi - bo'sh qoldirilsa bugungi sana ishlatiladi
        date: moment().format('YYYY-MM-DD')
    };

    const [inputs, setInputs] = useState(defaultValues);
    const [errors, setErrors] = useState({});

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = {
            transport_id: transport_id,
            client_id: inputs.client_id,
            driver_id: inputs.driver_id,
            round: inputs.round,
            price: inputs.price,
            date: inputs.date,
            material_id: inputs.material_id || null,
        };
        const res = await dispatch(addForTransportProductDelivery(data, transport_id));

        if (res) {
            dispatch(getForTransportProductDeliveries(transport_id))
            onClose();
        }
    };
    const handleSelect = (data, type) => {
        setErrors({});
        // data is null when a clearable select (material) is cleared
        setInputs(prevState => ({...prevState, [type.name]: data ? data.value : ''}))
    };
    const handleChange = e => {
        setErrors({});
        e.target.oldValue = e.target.value;
        setInputs(prevState => ({...prevState, [e.target.name]: e.target.value}));
    };

    useEffect(() => {
        if (error && loading === false) {
            const errorsItems = error?.errors;
            let errorObject = {};
            if (error && error?.errors) {
                Object.keys(error?.errors).forEach((item, index) => errorObject[item] = errorsItems[item][0]);
            }
            setErrors(errorObject);
        }
    }, [error]);

    useEffect(() => {
        clearErrors();
        setErrors({});
        setInputs(defaultValues);
    }, [transport_product_deliveries]);

    const onClose = () => {
        clearErrors();
        setInputs(defaultValues);
        setErrors({});
        handleClose();
    };


    return (
        <Fragment>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Yangi mahsulot yetkazib berish qo'shish</Modal.Title>
                </Modal.Header>

                <Modal.Body className="pt-3 pb-4 mx-3">

                    <form onSubmit={handleSubmit} ref={formRef}>

                        <div className="mb-3">
                            <label htmlFor="client_id">Mijoz</label>
                            <Select
                                name={'client_id'}
                                options={clientOptions}
                                onChange={handleSelect}
                                value={getSelectedOption(inputs.client_id, clientOptions)}
                                defaultValue={{label: 'Tanlang', value: '-'}}
                            />

                            <div className="error">
                                {errors?.client_id}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="driver_id">Haydovchi</label>
                            <Select
                                name={'driver_id'}
                                options={driverOptions}
                                onChange={handleSelect}
                                value={getSelectedOption(inputs.driver_id, driverOptions)}
                                defaultValue={{label: 'Tanlang', value: '-'}}
                            />

                            <div className="error">
                                {errors?.driver_id}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="material_id">Material <small className="text-muted">(ixtiyoriy)</small></label>
                            <Select
                                name={'material_id'}
                                options={materialOptions}
                                onChange={handleSelect}
                                value={getSelectedOption(inputs.material_id, materialOptions) || null}
                                isClearable={true}
                                placeholder={'Tanlang (ixtiyoriy)'}
                            />

                            <div className="error">
                                {errors?.material_id}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="round">Qatnov(reys)</label>
                            <input
                                name="round"
                                className={'form-control'}
                                type="number"
                                value={inputs?.round || ''}
                                placeholder={'kiriting'}
                                onChange={handleChange}
                                onKeyUp={e => e.target.oldValue = e.target.value}
                            />

                            <div className="error">
                                {errors?.round}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="price">Narxi</label>
                            <input
                                name="price"
                                className={'form-control'}
                                type="number"
                                value={inputs?.price || ''}
                                placeholder={'kiriting'}
                                onChange={handleChange}
                                onKeyUp={e => e.target.oldValue = e.target.value}
                            />

                            <div className="error">
                                {errors?.price}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="date">Sana</label>
                            <input
                                name="date"
                                id="date"
                                className={'form-control'}
                                type="date"
                                value={inputs?.date || ''}
                                onChange={handleChange}
                            />

                            <div className="error">
                                {errors?.date}
                            </div>
                        </div>

                        <div className="d-flex gap-2">
                            <Button className="w-50" variant="secondary" type="button" onClick={onClose}>Bekor
                                qilish</Button>
                            <Button className="w-50" variant="primary" type="submit">Saqlash</Button>
                        </div>

                    </form>


                </Modal.Body>

            </Modal>
        </Fragment>
    );
};

// TransportProductDeliveryCreateForm.propTypes = {
//     addForTransportProductDelivery: PropTypes.func.isRequired,
// };

// const mapStateToProps = (state) => ({
//     product_delivery: state.product_delivery,
//     error: state.transport.error,
//     loading: state.transport.loading,
//     transport_product_deliveries: state.transport.transport_product_deliveries,
// });


export default TransportProductDeliveryCreateForm;
